namespace TabAurous.Finance {
    export namespace PDCPayableService {
        export const baseUrl = 'Finance/PDCPayable';

        export declare function Create(request: Serenity.SaveRequest<PDCPayableRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDCPayableRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDCPayableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDCPayableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function VoucherList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDCPayableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Finance/PDCPayable/Create",
            Update = "Finance/PDCPayable/Update",
            Delete = "Finance/PDCPayable/Delete",
            Retrieve = "Finance/PDCPayable/Retrieve",
            List = "Finance/PDCPayable/List",
            VoucherList = "Finance/PDCPayable/VoucherList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'VoucherList'
        ].forEach(x => {
            (<any>PDCPayableService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
